import React, { Fragment, useEffect, useState } from 'react';
import { Col, Form, FormGroup, Label, Row } from 'reactstrap';
import TextInput from '../../../components/InputFields/TextInput';
import { useFormik } from 'formik';
import "./CreateWorkflow.css";
import { Accordion, AccordionBody, Input, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { formikAddWorkflow } from '../Constant';
import { useDispatch, useSelector } from 'react-redux';
import { failed, success } from '../../../utils/Tostify';
import { createWorkflow, getApplicationType, getDocumentTypeList, getPdfFormList } from '../../../api/workflow';
import { decryptData } from '../../../utils/helper';
import Loader from '../../../components/Loader/Loader';
import { useGetStates } from '../../../hooks/useGetStates';


function AddWorkflow({setCurrentTab}) {
    let token = useSelector(state => state.userReducer.token);
    const dispatch  = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [applicationList, setApplicationList] = useState(false);
    const [documentList, setDocumentList] = useState([]);
    const [applicationStages, setApplicationStages] = useState([]);
    const [formList, setFormList] = useState([]);
    const [open, setOpen] = useState('1');
    const [childStage, setChildStage] = useState({});
    const [childStageLast, setChildStageLast] = useState([]);
    const { states } = useGetStates("US");
    const [statesList, setStateList] = useState([]);

    useEffect(() => {
        if (states && states.length > 0) {
            const formattedStates = states.map((obj) => ({
                label: obj.name,
                value: obj.name
            }));
            setStateList(formattedStates);
        }
    }, [states]);

    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };
    const [activeTab, setActiveTab] = useState('1');

    const formik = useFormik({
        ...formikAddWorkflow,
        onSubmit: async (values) => {
            let res;
            try {
                handleNext(values);
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }
    });

    const handleSubmit = async(values) =>{
        values.signStage = {stage : values.signStage, childStage: values.signStageLast };
        setIsLoading(true);
        let res = await createWorkflow({ values, dispatch, token });
        if (res?.status == "SUCCESS") {
            setIsLoading(false);
            success(res?.message);
            formik.resetForm();
            setCurrentTab("workflowList");
        }else{
            setIsLoading(false);
            failed(res?.message);
        }
    };

    const handleBack = ()=>{
        switch (activeTab) {
            case "2": setActiveTab("1");
            break;
            case "3": setActiveTab("2");
            break;
            case "4": setActiveTab("3");
            break;
            case "5": setActiveTab("4");
            break;
            case "6": setActiveTab("5");
            break;
            default: return null; // Or a default component if necessary
        }
    };

    const handleNext = (values) => {
        switch (activeTab) {
            case "1":
                if (values.workflowTitle === "") {
                    formik.setFieldError("workflowTitle", "Required Field");
                    return false;
                }
                setActiveTab("2");
                break;
            case "2":
                if (values.stateId === "") {
                    formik.setFieldError("stateId", "Required Field");
                    return false;
                }
                setActiveTab("3");
                break;
            case "3":
                if (values.applicationTypeId === "") {
                    formik.setFieldError("applicationTypeId", "Required Field");
                    return false;
                }
                setActiveTab("4");
                break;
            case "4":
                if (values.pdfFormIds.length === 0) {
                    formik.setFieldError("pdfFormIds", "Required Field");
                    return false;
                }
                setActiveTab("5");
                break;
            case "5": {
                if (values.documentType.length === 0) {
                    formik.setFieldError("documentType", "Required Field");
                    return false;
                }
                const stageValidation = values.documentType.some(doc => !doc.stage);
                if (stageValidation) {
                    formik.setFieldError("documentType", "Please select Stage for document");
                    return false;
                }
                const childStageValidation = values.documentType.some(doc => {
                    const hasChildStages = childStage[doc._id]?.length > 0;
                    return hasChildStages && !doc.childStage;
                });
                if (childStageValidation) {
                    formik.setFieldError("documentType", "Please select Child Stage for applicable documents");
                    return false;
                }
                setActiveTab("6");
                break;
            }
            case "6":
                if(values.isSignStageRequired){
                    if (values.signStage === "") {
                        formik.setFieldError("signStage", "Required Field");
                        return false;
                    }
                }
                handleSubmit(values);
                break;
            default:
                return null; // Or a default action/component if necessary
        }
    };


    const getDocumentList = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);
            // setSearch(searchKey);
            res = await getDocumentTypeList({dispatch, token, page, limit, searchKey, dataLimit: "all"});
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setDocumentList(responseData?.items);
                setIsLoading(false);
            }else{
              setIsLoading(false);
              failed(res?.message);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    const getApplicationTypeList = async (page, limit, searchKey = "") => {
    let res;
    try {
        setIsLoading(true);
        // setSearch(searchKey);
        res = await getApplicationType({dispatch, token, page, limit, searchKey, dataLimit: "all"});
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
            setApplicationList(responseData?.items.filter((item)=> item?.isPublished !== false).map((obj)=> {
                return {
                label : obj?.applicationTitle,
                value : obj?._id,
                stages : obj?.applicationStages
            };}));
            setIsLoading(false);
        }else{
            setIsLoading(false);
            failed(res?.message);
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
    };

    const handleStates = (e)=>{
        formik.setFieldValue("stateId", e.target.value);
        formik.setFieldValue("state", statesList.find((obj)=> obj.value == e.target.value));
    };

    const getPdfForms = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);
            // setSearch(searchKey);
            res = await getPdfFormList({dispatch, token, page, limit, searchKey});
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setFormList(responseData);
                setIsLoading(false);
            }else{
              setIsLoading(false);
              failed(res?.message);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    const handlePdfForms = (e)=>{
        const { value, checked } = e.target;
        if (checked) {
          formik.setFieldValue('pdfFormIds', [...formik.values.pdfFormIds, value]);
        } else {
          formik.setFieldValue('pdfFormIds', formik.values.pdfFormIds.filter((item) => item !== value));
        }
    };

    const handleDocument = (e) => {
        const { value, checked } = e.target;
        const docId = e.target.id;
        if (checked) {
            formik.setFieldValue('documentType', [
                ...formik.values.documentType,
                {
                    _id: docId,
                    name: value,
                    stage: ""
                }
            ]);
        } else {
            formik.setFieldValue('documentType', formik.values.documentType.filter((item) => item._id !== docId));
        }
    };
    const handleStage = (docId, stageValue) => {
        const isDocChecked = formik.values.documentType.find((obj)=> obj._id == docId);
        if(!isDocChecked){
            failed("Please select document first.");
            formik.setFieldError("documentType", "Please select document first.");
            return true;
        }
        const updatedDocumentType = formik.values.documentType.map((item) => {
            if (item._id === docId) {
                return {
                    ...item,
                    stage: stageValue
                };
            }
            return item;
        });
        formik.setFieldValue('documentType', updatedDocumentType);
        setChildStage((prev) => ({
            ...prev,
            [docId]: applicationList.find((obj)=> obj?.value === formik.values.applicationTypeId).stages?.find((obj)=> obj?._id === stageValue)?.child?.map((obj)=> {
                return {
                    value: obj?._id,
                    label: obj?.name
                };
            }) // Directly assign options based on your logic
          }));
    };

    const handleChildStage = (e, docId) => {
        const updatedDocumentType = formik.values.documentType.map((item) => {
          if (item._id === docId) {
            return { ...item, childStage: e.target.value };
          }
          return item;
        });
        formik.setFieldValue("documentType", updatedDocumentType);
    };

    useEffect(() => {
      getDocumentList();
      getApplicationTypeList();
      getPdfForms();
    }, []);
    return (
        <Fragment>
            {isLoading && <Loader/>}
            <div className="add_document_type application_details applications-container m-0 p-0">
                <Form onSubmit={formik.handleSubmit}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
                            e.preventDefault();
                        }
                    }}
                >
                    {/* <h6 className="block_name text-center mt-3">Create Workflow</h6> */}
                    <div className='add_document_type_block'>
                        <h6 className="block_name text-center mt-3">Create Workflow</h6>
                        <div className="">
                            <Nav tabs className="profile_intab horizontal-scroll d-flex ">
                                   <NavItem className='first_tab_head'>
                                    <NavLink className={activeTab === '1' ? 'active' : ''}>
                                        Start
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={activeTab === '2' ? 'active' : ''}>
                                        State
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={activeTab === '3' ? 'active' : ''} >
                                        Application type
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={activeTab === '4' ? 'active' : ''}>
                                        PDF Forms
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={activeTab === '5' ? 'active' : ''}>
                                        Document type
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={activeTab === '6' ? 'active' : ''}>
                                        Sign
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                        <div className="tab-top">
                            <div>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <Accordion open={open} toggle={toggle}>
                                            <AccordionBody accordionId="1" className="abc">
                                                <Row className='mt-3'>
                                                    <Col lg={12} className="location_block">
                                                        <TextInput
                                                            keyField={"workflowTitle"}
                                                            formik={formik}
                                                            label="Workflow Title"
                                                            type="text"
                                                            value={formik.values.workflowTitle}
                                                            onChange={(e) => formik.setFieldValue("workflowTitle", e.target.value)}
                                                        />
                                                    </Col>
                                                </Row>
                                            </AccordionBody>
                                        </Accordion>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Accordion open={open} toggle={toggle}>
                                            <AccordionBody accordionId="1" className="form_tab">
                                                <Row className='mt-3'>
                                                    <Col lg={12} className="location_block">
                                                        <TextInput
                                                            keyField={"stateId"}
                                                            formik={formik}
                                                            label="State"
                                                            options={statesList}
                                                            type="select"
                                                            value={formik.values.stateId}
                                                            onChange={(e) => handleStates(e)}
                                                        />
                                                    </Col>
                                                </Row>
                                            </AccordionBody>
                                        </Accordion>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <Accordion open={open} toggle={toggle}>
                                            <AccordionBody accordionId="1" className="form_tab">
                                                <Row className='mt-3'>
                                                    <Col lg={12} className="location_block">
                                                        <TextInput
                                                            keyField={"applicationTypeId"}
                                                            formik={formik}
                                                            options={applicationList}
                                                            label="Application Type"
                                                            type="select"
                                                            value={formik.values.applicationTypeId}
                                                            onChange={(e) => {formik.setFieldValue("applicationTypeId", e.target.value); setApplicationStages(applicationList.find((app) => app.value ==  e.target.value).stages.map((obj)=> {return {label: obj?.name, value : obj?._id };}));}}
                                                        />
                                                    </Col>
                                                </Row>
                                            </AccordionBody>
                                        </Accordion>
                                    </TabPane>
                                    <TabPane tabId="4">
                                        <Accordion open={open} toggle={toggle}>
                                            <AccordionBody accordionId="1" className="form_tab mt-3">
                                                <Label>PDF Forms</Label>
                                                <div className='table-responsive'>
                                                <table>
                                                    <thead>
                                                        <tr className="header_table">
                                                            <th>Select</th>
                                                            <th>Name</th>
                                                        </tr>
                                                    </thead>
                                                    {formList.items
                                                        ?.filter(form => form.state?.label === formik.values.stateId)
                                                        .map((form, index) => (
                                                            <tbody key={form._id}>
                                                            <tr>
                                                                <td colSpan={8} className="bg_light"></td>
                                                            </tr>
                                                            <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                                                <td>
                                                                <FormGroup check className="custom-checkbox">
                                                                    <Input
                                                                    type="checkbox"
                                                                    id={form?._id}
                                                                    value={form?._id}
                                                                    onClick={handlePdfForms}
                                                                    />
                                                                </FormGroup>
                                                                </td>
                                                                <td>{form.formTitle}</td>
                                                            </tr>
                                                            </tbody>
                                                        ))
                                                    }
                                                </table>
                                                </div>
                                                {formik?.touched["pdfFormIds"] && formik?.errors["pdfFormIds"] ? <span style={{color : "red"}}>{formik?.errors["pdfFormIds"]}</span> : ""}
                                            </AccordionBody>
                                        </Accordion>
                                    </TabPane>
                                    <TabPane tabId="5">
                                        <Accordion open={open} toggle={toggle}>
                                            <AccordionBody accordionId="1" className="form_tab mt-3">
                                                <Label>Document Types</Label>
                                                <div className='table-responsive'>
                                                <table>
                                                    <thead>
                                                        <tr className="header_table">
                                                            <th>Select</th>
                                                            <th>Name</th>
                                                            <th>Stage</th>
                                                            <th>Child Stage</th>
                                                        </tr>
                                                    </thead>
                                                    {documentList.length > 0 &&  documentList.map((doc,index)=> (<tbody key={doc?._id}>
                                                        <tr>
                                                            <td colSpan={8} className="bg_light"></td>
                                                        </tr>
                                                        <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                                            <td><FormGroup check className="custom-checkbox">
                                                                <Input type="checkbox" id={doc?._id} value={doc?.documentTitle} onClick={handleDocument}/>
                                                            </FormGroup></td>
                                                            <td>{doc?.documentTitle}</td>
                                                            <td className='table_form'>
                                                                <TextInput
                                                                    keyField={"docStage"}
                                                                    formik={formik}
                                                                    options={applicationStages}
                                                                    type="select"
                                                                    value={formik.values.documentType.find(item => item._id === doc._id)?.stage || ""}
                                                                    onChange={(e)=> handleStage(doc._id, e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                {childStage[doc._id]?.length > 0 ? <TextInput
                                                                    keyField={"signChildStage"}
                                                                    formik={formik}
                                                                    options={childStage[doc._id]}
                                                                    type="select"
                                                                    value={formik.values.documentType.find(item => item._id === doc._id)?.childStage || ""}
                                                                    onChange={(e)=> handleChildStage(e, doc._id)}
                                                                /> : null}
                                                            </td>
                                                        </tr>
                                                    </tbody>))}
                                                </table>
                                                </div>
                                                {formik?.touched["documentType"] && formik?.errors["documentType"] ? <span style={{color : "red"}}>{formik?.errors["documentType"]}</span> : ""}
                                            </AccordionBody>
                                        </Accordion>
                                    </TabPane>
                                    <TabPane tabId="6">
                                        <Accordion open={open} toggle={toggle}>
                                            <AccordionBody accordionId="1" className="form_tab mt-3">
                                                <Row>
                                                    <Col lg={6} className="location_block mb-3 d-flex justify-content-start">
                                                        <FormGroup check className="custom-checkbox box-two">
                                                            Add Sign Stage <Input type="checkbox" id={"radio2"} name={`formCheckbox`} value={formik.values.isSignStageRequired} onClick={(e)=> formik.setFieldValue("isSignStageRequired" , e.target.checked)}/>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                {formik.values.isSignStageRequired ? <Row>
                                                    <Col lg={6} className="location_block">
                                                        <TextInput
                                                            keyField={"signStage"}
                                                            formik={formik}
                                                            label="Stage"
                                                            options={applicationStages}
                                                            type="select"
                                                            value={formik.values.signStage}
                                                            onChange={(e) => {
                                                                formik.setFieldValue("signStage", e.target.value);
                                                                setChildStageLast(applicationList.find((obj)=> obj?.value === formik.values.applicationTypeId).stages?.find((obj)=> obj?._id === e.target.value)?.child?.map((obj)=> {
                                                                    return {
                                                                        value: obj?._id,
                                                                        label: obj?.name
                                                                    };
                                                                }));
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col lg={6} className="location_block">
                                                        {childStageLast?.length > 0 ?  <TextInput
                                                            keyField={"signStageLast"}
                                                            formik={formik}
                                                            label="Child Stage"
                                                            options={childStageLast}
                                                            type="select"
                                                            value={formik.values.signStageLast}
                                                            onChange={(e) => {
                                                                formik.setFieldValue("signStageLast", e.target.value);
                                                            }}
                                                        /> : null}
                                                    </Col>
                                                </Row> : null}
                                            </AccordionBody>
                                        </Accordion>
                                    </TabPane>
                                </TabContent>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex justify-content-between align-items-end'>
                        <button
                            className="save_btn saving"
                            type="button"
                            style={{
                                backgroundColor: activeTab == "1" ? "lightgrey" : null, // Replace #primaryColor with your desired color when enabled
                                cursor: activeTab == "1" ? "not-allowed" : "pointer", // Optional: change cursor when disabled
                                color: activeTab == "1" ? "white" : null, // Optional: change text color when disabled
                                border: activeTab == "1" ? "none" : null  // Optional: change border when disabled
                              }}
                              onClick={handleBack}
                        > Back</button>
                        <div className="d-flex gap-3 justify-content-end mt-5 button_blkj">
                            <button className="save_btn cancel_btn" onClick={()=> setCurrentTab("workflowList")}>Cancel</button>
                            <button className="save_btn" type="submit">{activeTab == "6" ? "Save" : "Next"}</button>
                        </div>
                    </div>
                </Form>
            </div>
        </Fragment>
    );
}

export default AddWorkflow;
